export default "__VITE_ASSET__CQIKgviL__"